import React from 'react';
import { Box } from '@mui/material';
import { useSafeBrand } from '../hooks/useSafeBrand';
import { currentBrand } from '../config/branding';

interface BrandLogoProps {
  width?: number | string;
  height?: number | string;
  sx?: object;
}

export const BrandLogo: React.FC<BrandLogoProps> = ({ width = 40, height = 40, sx = {} }) => {
  // Use fallback branding when ServerBrandProvider is not available
  const { brand, loading } = useSafeBrand();

  if (loading || !brand) {
    return (
      <Box
        sx={{
          width,
          height,
          backgroundColor: '#f0f0f0',
          borderRadius: 1,
          ...sx,
        }}
      />
    );
  }

  const logoUrl = brand.logoUrl || currentBrand.logo;
  const brandName = brand.brandName || currentBrand.name;

  return (
    <Box
      key={`${brand.tenantId}-${logoUrl}`} // Force re-render when tenant or logo changes
      component="img"
      src={logoUrl}
      alt={`${brandName} Logo`}
      sx={{
        width,
        height,
        objectFit: 'contain',
        ...sx,
      }}
      onError={e => {
        // Fallback to the static brand logo if the server-driven logo fails to load
        (e.target as HTMLImageElement).src = currentBrand.logo;
      }}
    />
  );
};
